export default __webpack_public_path__ + "static/media/gallery8.fdb294aa.png";